<div class="theme-loader">
  <div class="ball-scale" aria-hidden="true">
    <div class="contain">
      <div class="ring">
        <div class="frame"></div>
      </div>
      <div class="ring">
        <div class="frame"></div>
      </div>
      <div class="ring">
        <div class="frame"></div>
      </div>
      <div class="ring">
        <div class="frame"></div>
      </div>
      <div class="ring">
        <div class="frame"></div>
      </div>
      <div class="ring">
        <div class="frame"></div>
      </div>
      <div class="ring">
        <div class="frame"></div>
      </div>
      <div class="ring">
        <div class="frame"></div>
      </div>
      <div class="ring">
        <div class="frame"></div>
      </div>
      <div class="ring">
        <div class="frame"></div>
      </div>
    </div>
  </div>

  <p
    class="loader-message"
    [class.loader-message--visible]="!!loaderService.message()"
    role="status"
    aria-live="polite"
    aria-atomic="true">
    {{ loaderService.message() }}
  </p>
</div>
